<div class="report-type-icon {{typeClass}}">
  <capra-icon [icon]="icon"></capra-icon>
</div>
